export const zh = "common/zh.json";
export const en = "common/en.json";



// WEBPACK FOOTER //
// ./src/assets/i18n/common/index.ts